<template functional>
  <v-list dark class="list-item">
    <v-list-tile ripple v-on="listeners">
      <v-list-tile-avatar>
        <v-icon>arrow_back</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-title class="list-item__title">{{ props.text }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables.styl";

.list-item {
  padding-top: 0;
  padding-bottom 0;
  box-shadow: inset 0 -1px 0 0 #000;

  &__title {
    color: $nx-primary--lighten-5
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
  }
}
</style>
